export default {"src":"/_next/static/media/logo-ana.0f92bc16.gif","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};